import ThreeDotsLoader from "@atoms/loaders/three-dots"
import { forwardRef } from "react"
import { BaseButton, BaseButtonLabel, BaseLabeled, BaseLoading } from "./styles"

export interface IButton extends React.ComponentPropsWithRef<"button"> {
  color?: "default" | "primary" | "secondary" | "danger" | "warning" | "success"
  variant?:
    | "default"
    | "link"
    | "labeled"
    | "labeled-dark"
    | "labeled-outlined"
    | "outlined"
  size?: "default" | "small"
  labelIcon?: React.ReactNode
  rounded?: boolean
  fullWidth?: boolean
  isLoading?: boolean
}

const typography = {
  small: "caption-heavy",
  default: "body-heavy",
}

const Button: React.FC<IButton> = forwardRef(
  (
    {
      color = "default",
      variant = "default",
      size = "default",
      rounded,
      fullWidth,
      labelIcon,
      isLoading,
      className = "",
      children,
      onClick,
      ...props
    },
    ref
  ) => {
    return (
      <BaseButton
        ref={ref}
        rounded={rounded}
        fullWidth={fullWidth}
        className={`color--${color} variant--${variant} size--${size} ${
          isLoading ? "loading" : ""
        } ${typography[size]} ${className}`}
        onClick={isLoading ? undefined : onClick}
        {...props}
      >
        <BaseButtonLabel
          className={size === "default" ? "body-heavy" : "caption-heavy"}
        >
          {children}
        </BaseButtonLabel>

        {variant.startsWith("labeled") && labelIcon && (
          <BaseLabeled rounded={rounded}>{labelIcon}</BaseLabeled>
        )}
        {isLoading && (
          <BaseLoading>
            <ThreeDotsLoader size={8} />
          </BaseLoading>
        )}
      </BaseButton>
    )
  }
)

Button.displayName = "Button"

export default Button
